export default "__VITE_ASSET__2tsdouPk__"